<template>
  <section>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <h1>Inventory levels</h1>
        </v-col>
      </v-row>

      <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
        <v-col cols="12" sm="12" md="3">
          <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            label="Choose a depot"
            :items="depots"
            item-text="name"
            item-value="id"
            v-model="depot_id"
            prepend-icon="fas fa-warehouse"
          ></v-select>
        </v-col>


        <v-col cols="12" md="4" class="d-flex justify-space-around">
          <div>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>

          </div>
        </v-col>

      </v-row>
    </v-container>

    <v-divider></v-divider>

    <v-data-table
      :search="search"
      :headers="headers"
      :items="renderedInventoryLevels"
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td  style="text-align: center"
              v-for="(header, index) in headers"
              :key="index">{{props.item[header.value]}}
          </td>
<!--          <td class="text-center">-->
<!--            {{props.item.climate.name}}-->
<!--          </td>-->
<!--          <td class="text-center" v-if="isInventoryManager">-->
<!--            <v-tooltip top color="secondary">-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <v-icon @click="editRow(props.item)" color="blue" v-on="on">-->
<!--                  edit-->
<!--                </v-icon>-->
<!--              </template>-->
<!--              <span>Edit</span>-->
<!--            </v-tooltip>-->
<!--            <v-tooltip top color="secondary">-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <v-icon @click="deleteRow(props.item)" color="red" v-on="on" class="pl-1">-->
<!--                  delete-->
<!--                </v-icon>-->
<!--              </template>-->
<!--              <span>Delete</span>-->
<!--            </v-tooltip>-->
<!--          </td>-->
        </tr>
      </template>
    </v-data-table>


<!--    <v-dialog-->
<!--      v-model="deleteDialog"-->
<!--      max-width="500px"-->
<!--    >-->
<!--      <v-card>-->
<!--        <v-card-title class="justify-center">-->
<!--          <h3>ATTENTION</h3>-->
<!--        </v-card-title>-->
<!--        <v-card-text class="text-center">-->
<!--          You are about to delete this Inventory Level. This action cannot be undone. <br>-->
<!--          Are you sure you want to proceed ?-->
<!--        </v-card-text>-->
<!--        <v-card-actions class="justify-center">-->
<!--          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>-->
<!--          <v-btn text @click="DeleteItem" color="blue darken-1">Yes</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </section>

</template>

<script>
    import axios from 'axios';

    export default {
        name: "InventoryLevelsDataTable",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                depots: null,
                toBeDeleted: null,
                deleteDialog: false,
                climates: null,
                clients: null,
                depot_id: 1,
            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000);
            this.getClimates();
            this.getDepots();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            headers() {
                let headers = [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    //{text: 'Pallet count', value: 'pallet_count', align: 'center', sortable: true},
                    {text: 'Name of item', value: 'name', align: 'center', sortable: false},
                    {text: 'Item count', value: 'item_count', align: 'center', sortable: true},
                    {text: 'SKU', value: 'sku', align: 'center', sortable: false},
                    {text: 'Climate', value: 'climate_name', align: 'center', sortable: false},
                    {text: 'Expired', value: 'expired_date', align: 'center', sortable: false},
                ];
                if (!this.isInternalUser) {
                    headers.unshift({text: 'Client name', value: 'client_name', align: 'center', sortable: false});
                }
                return headers;
            },
            renderedInventoryLevels() {
                if (this.InventoryLevels === null || this.InventoryLevels === undefined) {
                    return [];
                } else {
                    return this.InventoryLevels;
                }
            },
        },
        asyncComputed: {
            async InventoryLevels() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/items/inventorylevels?depot_id=' + this.depot_id)
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            },
        },
        methods: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            isInventoryManager() {
                return this.$store.getters['auth/inventory_manage'];
            },
            updateDataTable() {
                this.reload = !this.reload;
            },
            // @vuese
            // Gets all the depots
            getDepots() {
                axios.get(process.env.API_URL + '/depots?wms=true')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            DeleteItem() {
                axios.delete(process.env.API_URL + '/items/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this.$store.commit('displaySnackbar', 'Delete successful');
                        this.updateDataTable();
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                    });
                this.updateDataTable();
            },
            // @vuese
            // Gets all the climates
            getClimates() {
                axios.get(process.env.API_URL + '/climates')
                    .then((response) => {
                        this.climates = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the clients
            getClients() {
                axios.get(process.env.API_URL + '/clients?active=true')
                    .then((response) => {
                        this.clients = Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/InventoryLevelsDatatable.vue